import React from "react";
import styled from "styled-components";
import Container from "../../Components/Container";
import Row from "../../Components/Row";
import ScreensImage from "../../assets/images/wpp.svg";
import AlertIcon from "../../assets/images/alert-gif.gif";
import RobotIcon from "../../assets/images/robot-gif.gif";
import AnalyticsIcon from "../../assets/images/analytics-gif.gif";
import ChatIcon from "../../assets/images/chat-gif.gif";
import WhatsappIcon from "../../assets/images/wpp-logo.svg";
import Button from "../../Components/Button";
import PlayStoreIcon from "../../assets/images/google-play.svg";
import AppleIcon from "../../assets/images/apple.svg";

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    display: grid;
  }
`;

const Title = styled.h1`
  font-weight: 700;
  font-size: 40px;
  margin: 0px;

  span {
    color: #4162fd;
  }
`;

const WhatsappImage = styled.img`
  width: 71px;
  margin-left: 8px;

  @media (max-width: 768px) {
    margin: 10px auto;
  }
`;

const SpanText = styled.span`
  font-weight: 300;
  font-size: 20px;
  line-height: 30px;
`;

const InfoCard = styled.div`
  display: flex;
  align-items: center;
  padding: 40px;
  border-radius: 14px;
  background-color: #fff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
`;

const IconWrapper = styled.div`
  width: 48px;
  height: 48px;
  margin-right: 24px;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
`;

const TitleCard = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #000;
`;

const SubtitleCard = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #000;
  margin-top: 4px;
`;

const Whatsapp = () => {
  return (
    <Container style={{ textAlign: "center" }} id="section-1">
      <br />
      <br />
      <Header>
        <Title>
          Cobrança <span>inteligente</span> via Whatsapp
        </Title>
        <WhatsappImage src={WhatsappIcon} />
      </Header>
      <SpanText>
        Agora a Room vai além da gestão de contratos: usamos{" "}
        <SpanText style={{ fontWeight: 600 }}>inteligência artificial</SpanText>
        <br />
        para lembrar seus inquilinos sobre aluguéis a vencer, notificações de
        atraso e até
        <br /> para tirar dúvidas diretamente no WhatsApp.
      </SpanText>
      <Row
        xs="1fr"
        sm="1fr"
        md="auto 60%"
        lg="auto 60%"
        xl="auto 60%"
        style={{ marginTop: "80px", alignItems: "center" }}
      >
        <img
          src={ScreensImage}
          alt="Celulares"
          width={"80%"}
          style={{ margin: "auto" }}
        />
        <div>
          <InfoCard>
            <IconWrapper>
              <img src={AlertIcon} alt="Icon" />
            </IconWrapper>
            <TextContent>
              <TitleCard>Alertas automáticos de vencimento e atraso</TitleCard>
              <SubtitleCard>
                O inquilino é avisado no momento certo, sem esforço seu.
              </SubtitleCard>
            </TextContent>
          </InfoCard>
          <InfoCard>
            <IconWrapper>
              <img src={RobotIcon} alt="Icon" />
            </IconWrapper>
            <TextContent>
              <TitleCard>Assistência 24h com IA GPT-4</TitleCard>
              <SubtitleCard>
                Respostas imediatas sobre cláusulas, datas e status do contrato.
              </SubtitleCard>
            </TextContent>
          </InfoCard>
          <InfoCard>
            <IconWrapper>
              <img src={AnalyticsIcon} alt="Icon" />
            </IconWrapper>
            <TextContent>
              <TitleCard>Menos inadimplência, mais organização</TitleCard>
              <SubtitleCard>
                Com comunicação direta e humanizada, o pagamento chega em dia.
              </SubtitleCard>
            </TextContent>
          </InfoCard>
          <InfoCard>
            <IconWrapper>
              <img src={ChatIcon} alt="Icon" />
            </IconWrapper>
            <TextContent>
              <TitleCard>Tudo acontece no WhatsApp</TitleCard>
              <SubtitleCard>
                A plataforma mais usada pelos brasileiros agora trabalha a seu
                favor.
              </SubtitleCard>
            </TextContent>
          </InfoCard>
        </div>
      </Row>
    </Container>
  );
};

export default Whatsapp;
